module.exports = __webpack_public_path__ + "static/img/banner01.2b6497e7.png";